import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { EmailTemplateAdmin } from '../types/email_template_admin/EmailTemplateAdmin';
import { UpdateEmailTemplateAdminRequest } from '../types/email_template_admin/UpdateEmailTemplateAdminRequest';
import { DataResponse, PagedResponse } from '../types';

const BASE_URL = '/v2/admin/email-templates';

class EmailTemplateAdminService {
  static getByFilter(
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<PagedResponse<EmailTemplateAdmin>>> {
    return axios.get<PagedResponse<EmailTemplateAdmin>>(BASE_URL, config);
  }

  static partialUpdate(
    id: number,
    data: UpdateEmailTemplateAdminRequest,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<DataResponse<EmailTemplateAdmin>>> {
    return axios.patch<DataResponse<EmailTemplateAdmin>>(`${BASE_URL}/${id}`, data, config);
  }
}

export { EmailTemplateAdminService };